import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionSubtitleResponse } from './get-collection-subtitle-response';
import { getCollectionSubtitleResponseSchema } from './get-collection-subtitle-response';

interface IGetSubtitleByCollectionRequest {
  collectionId: number;
}

export async function getSubtitleByCollectionApi({
  collectionId,
}: IGetSubtitleByCollectionRequest): Promise<IValidatedResponse<IGetCollectionSubtitleResponse>> {
  return getRequest<IGetCollectionSubtitleResponse>({
    path: `/sys/subtitles/by-collection/${collectionId}`,
    schema: getCollectionSubtitleResponseSchema,
  });
}
